export const FETCH_STONE_CLARITY_REQUEST = 'FETCH_STONE_CLARITY_REQUEST';
export const FETCH_STONE_CLARITY_SUCCESS = 'FETCH_STONE_CLARITY_SUCCESS';
export const FETCH_STONE_CLARITY_FAILURE = 'FETCH_STONE_CLARITY_FAILURE';

export const ADD_STONE_CLARITY_REQUEST = 'ADD_STONE_CLARITY_REQUEST';
export const ADD_STONE_CLARITY_SUCCESS = 'ADD_STONE_CLARITY_SUCCESS';
export const ADD_STONE_CLARITY_FAILURE = 'ADD_STONE_CLARITY_FAILURE';

export const UPDATE_STONE_CLARITY_REQUEST = 'UPDATE_STONE_CLARITY_REQUEST';
export const UPDATE_STONE_CLARITY_SUCCESS = 'UPDATE_STONE_CLARITY_SUCCESS';
export const UPDATE_STONE_CLARITY_FAILURE = 'UPDATE_STONE_CLARITY_FAILURE';

export const DELETE_STONE_CLARITY_REQUEST = 'DELETE_STONE_CLARITY_REQUEST';
export const DELETE_STONE_CLARITY_SUCCESS = 'DELETE_STONE_CLARITY_SUCCESS';
export const DELETE_STONE_CLARITY_FAILURE = 'DELETE_STONE_CLARITY_FAILURE';

export const STONE_CLARITY_FORM_ERROR = 'STONE_CLARITY_FORM_ERROR';
export const STONE_CLARITY_FORM_SUCCESS = 'STONE_CLARITY_FORM_SUCCESS';
export const SET_STONE_CLARITY_EDIT = 'SET_STONE_CLARITY_EDIT';
export const CLEAR_STONE_CLARITY_EDIT = 'CLEAR_STONE_CLARITY_EDIT'; 